// src/components/BlogWidget.jsx
// Drop this into GoldRatesWebsite.js homepage — shows 3 latest articles
// with a "View all" link to /blog

import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Clock, ChevronRight } from 'lucide-react';
import { getRecentPosts, formatDate } from '../data/blogPosts';

export default function BlogWidget() {
  const posts = getRecentPosts(3);
  if (!posts.length) return null;

  return (
    <section className="max-w-6xl mx-auto px-6 pb-12">
      {/* Header */}
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-3">
          <BookOpen className="w-6 h-6 text-yellow-600" />
          <h2 className="text-xl font-bold text-gray-800">Latest Gold News &amp; Guides</h2>
        </div>
        <Link
          to="/blog"
          className="text-sm text-yellow-600 font-semibold flex items-center gap-1 hover:gap-2 transition-all"
        >
          View all articles <ChevronRight className="w-4 h-4" />
        </Link>
      </div>

      {/* Post cards */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {posts.map(post => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="group bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-200 overflow-hidden flex flex-col"
          >
            {/* Category strip */}
            <div className="bg-gradient-to-r from-yellow-500 to-amber-500 px-4 py-2 flex items-center justify-between">
              <span className="text-white text-xs font-bold uppercase tracking-wider">{post.category}</span>
              <span className="text-yellow-100 text-xs flex items-center gap-1">
                <Clock className="w-3 h-3" />{post.readTime} min
              </span>
            </div>

            <div className="p-4 flex flex-col flex-1">
              <h3 className="font-bold text-gray-800 text-sm leading-snug mb-2 group-hover:text-yellow-600 transition-colors line-clamp-2">
                {post.title}
              </h3>
              <p className="text-gray-500 text-xs leading-relaxed flex-1 line-clamp-2 mb-3">
                {post.excerpt}
              </p>
              <div className="flex items-center justify-between text-xs text-gray-400 border-t border-gray-100 pt-2">
                <span>{formatDate(post.date)}</span>
                <span className="text-yellow-600 font-semibold">Read →</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
